export default "__VITE_ASSET__BmJFAk6p__"